// search.reducer.js
const initialState = {
    loading: false,
    query: '',
    results: [],
    categories: [],
    subCategories: [],
    products: [],
    error: null
};

const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SEARCH_REQUEST':
            return {
                ...state,
                loading: true,
                query: action.payload,
                error: null
            };

        case 'SEARCH_SUCCESS':
            return {
                ...state,
                loading: false,
                query: action.payload.query,
                results: action.payload.results,
                categories: action.payload.categories,
                subCategories: action.payload.subCategories,
                products: action.payload.products
            };

        case 'SEARCH_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case 'SEARCH_CLEAR':
            return initialState;

        default:
            return state;
    }
};

export default searchReducer;